﻿import controller from '../../../../resources/scripts/_shared/controller';

function collageContainerBlock(context) {
  const collageItems = Array.prototype.slice.call(context.querySelectorAll('.collageitemblock'));

  function init() {
    if (collageItems.length > 0) {
      collageItems.forEach(collageItem => { 
        context.appendChild(collageItem);
      })
    }
    
    const epiContainer = context.querySelector('h2 + .epi-editContainer');
    context.appendChild(epiContainer);
    epiContainer.style.display = 'none';
  }

  return {
    init
  };
}

controller.add('collage-container-block', collageContainerBlock);